import BigNumber from 'bignumber.js'

export function number(value) {
  const amount = Number(value)
  return amount.toLocaleString()
}

export function numberWithMaxPrecision(value, max=2){
  return new BigNumber(`${value}`).toFormat(max)
}